<lib-info-page [id]="id"></lib-info-page>